export function getApiBase(): string {
  if (typeof window !== "undefined" && window.location.protocol.startsWith("http")) {
    return `${window.location.origin}/api`;
  }
  const fromEnv = import.meta.env.VITE_API_URL?.trim();
  if (fromEnv) return fromEnv.replace(/\/$/, "");
  return "http://localhost:43124";
}
